export default "__VITE_ASSET__BOuIxTBq__"